import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@prisjakt/ui-inputs';
import * as S from './styles';

const TrackingSettingCheckbox = props => {
  let checked = !!props.checked;

  if (props.disabled) {
    checked = false;
  }

  return (
    <S.TrackingSetting indent={props.indent}>
      <Checkbox
        name={props.name}
        onChange={() => props.handleChange(props.name)}
        checked={checked}
        disabled={props.disabled}
      >
        {props.title}
      </Checkbox>
      {props.text}
    </S.TrackingSetting>
  );
};

TrackingSettingCheckbox.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  checked: PropTypes.number,
  disabled: PropTypes.bool,
  indent: PropTypes.bool,
};

TrackingSettingCheckbox.defaultProps = {
  checked: 0,
  disabled: false,
  indent: false,
};

export default TrackingSettingCheckbox;
